import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '@core/services/auth.service';
import { map, catchError, of } from 'rxjs';

export const authGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  return authService.checkAuthStatus().pipe(

    map((isAuthenticated) => {
      if (isAuthenticated) {
        return true;
      }
      router.navigate(['/auth']);
      return false;
    }),
    catchError((error) => {
      console.error('Error in authGuard:', error);
      router.navigate(['/auth']);
      return of(false);
    }),
  );
};
